/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetGoodsReceivedNoteDetails,
    GoodsReceivedNoteComplete,
    GetDirectSupplierDetails,
    GoodsReceivedNoteDownloadCount,
    GoodsReceivedNoteReject
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupIDV2', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetDirectSupplierDetails(operationEntityID) {
    const response = await CommonGet('/api/SpecialOrder/GetDirectSupplierDetails', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}

async function GetGoodsReceivedNoteDetails(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/GetGoodsReceivedNoteDetails', null, data);
    return response.data;
}

async function GoodsReceivedNoteComplete(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/GoodsReceivedNoteComplete', null, data);
    return response;
}

async function GoodsReceivedNoteDownloadCount(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/GoodsReceivedNoteDownloadCount', null, data);
    return response;
}

async function GoodsReceivedNoteReject(data) {
    const response = await CommonPost('/api/GoodsReceivedNote/GoodsReceivedNoteReject', null, data);
    return response;
}